export default __webpack_public_path__ + "static/media/you-lose.c474d680.png";